.video-widget {
    position: relative;
    width: 100%;
    height: 100%;
}

.video-widget--fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10000;
}

.video-widget__preview {
    position: fixed;
    width: 90px;
    height: 126px;
    z-index: 1000;
    transition: transform 0.2s ease;
}

.video-widget__preview.dragging {
    transform: scale(1.05);
}

.video-widget__preview.loading {
    opacity: 0.7;
}

.video-widget__thumbnail {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgb(0 0 0 / 20%);
    border: 2px solid #000;
    cursor: pointer;
}

.video-widget__thumbnail-media {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
}

.video-widget__thumbnail-media video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
}

.video-widget__thumbnail-description {
    position: absolute;
    top: 50%;
    left: 100%;
    background: #000;
    transform: translate(4px, -50%) scaleX(0);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 20px 20px 0;
    transform: scaleX(0);
    transform-origin: left;
    opacity: 0;
    overflow: hidden;
}

.video-widget__thumbnail-description--animate {
    animation: scaleFadeAndCollapse 4.25s ease-in-out forwards;
}

.video-widget__thumbnail-description-text {
    color: #FFF;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    width: 100%;
    padding: 10px;
    text-wrap: nowrap;
    text-transform: uppercase;
    white-space-collapse: collapse;
}

.video-widget__modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff0;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease;
    z-index: 9999999;
}

.video-widget__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0 0 0 / 60%);
    backdrop-filter: blur(4px);
}

.video-widget__player {
    position: absolute;
    background-color: #000;
    border-radius: 8px;
    animation: slideIn .3s ease-out;
    overflow: hidden;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
}

.video-widget__indicators {
    position: absolute;
    top: 20px;
    left: 20px;
    right: 20px;
    display: flex;
    gap: 4px;
    z-index: 10;
}

.video-widget__player-one .video-widget__indicators {
    top: 10px;
}

.video-widget__indicator {
    flex: 1;
    height: 3px;
    background: rgb(255 255 255 / 0.3);
    border-radius: 2px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.video-widget__indicator.active {
    background: rgb(255 255 255 / 0.5);
}

.video-widget__indicator.viewed {
    background: rgb(255 255 255 / 0.8);
}

.video-widget__progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #fff;
    transition: width 0.1s ease;
}

.video-widget__close {
    position: absolute;
    top: 40px;
    right: 10px;
    width: 40px;
    height: 40px;
    background-color: rgb(0 0 0 / 0.4);
    border: none;
    border-radius: 40px;
    color: #fff;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    z-index: 10;
}

.video-widget__player-one .video-widget__close {
    top: 20px;
}

.video-widget__close:hover {
    background-color: rgb(0 0 0 / 0.8);
}

.video-widget__close svg {
    width: 24px;
    height: 24px;
}

.video-widget__video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.video-widget__controls {
    position: absolute;
    bottom: 10px;
    right: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 10;
}

.video-widget__control {
    width: 40px;
    height: 40px;
    background-color: rgb(0 0 0 / 0.4);
    border: none;
    border-radius: 40px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background-color 0.2s;
}

.video-widget__control:hover {
    background-color: rgb(0 0 0 / 0.8);
}

.video-widget__control svg {
    width: 20px;
    height: 20px;
}

.video-widget__playback-controls {
    position: relative;
}

.video-widget__control--playback {
    font-size: 12px;
    font-weight: 700;
}

.video-widget__playback-controls-wrapper {
    position: absolute;
    bottom: 100%;
    right: 0;
    margin-bottom: 5px;
    background: rgb(0 0 0 / 0.9);
    border-radius: 6px;
    padding: 4px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 48px;
}

.video-widget__playback-controls-wrapper button {
    background: #fff0;
    border: none;
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    min-height: 30px;
}

.video-widget__playback-controls-wrapper button:hover,
.video-widget__playback-controls-wrapper button.active {
    background: rgb(255 255 255 / 0.2);
}

.video-widget__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
}

.video-widget__spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgb(255 255 255 / 0.3);
    border-top: 3px solid #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.video-widget__stories-indicators {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: flex;
    gap: 4px;
    z-index: 15;
}

.video-widget__story-indicator {
    flex: 1;
    height: 3px;
    background-color: rgb(0 0 0 / 0.3);
    border-radius: 2px;
    cursor: pointer;
    position: relative;
}

.video-widget__story-indicator.viewed {
    background-color: rgb(0 0 0 / 0.3);
}

.video-widget__story-indicator.active {
    background: #000;
}

.video-widget__indicators {
    position: absolute;
    top: 25px;
    left: 10px;
    right: 10px;
    display: flex;
    gap: 4px;
    z-index: 10;
}

.video-widget__arrow-controls {
    position: absolute;
    top: calc(50% - 20px);
    left: 0;
    display: flex;
    gap: 10px;
    z-index: 20;
    width: 100%;
}

.video-widget__arrow-btn {
    width: 40px;
    height: 40px;
    background-color: rgb(0 0 0 / 0.4);
    border: none;
    border-radius: 40px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background-color 0.2s;
    opacity: 1;
    visibility: visible;
    position: absolute;
    display: none;
}

.video-widget__arrow-btn:hover {
    background-color: rgb(0 0 0 / 0.8);
}

.video-widget__arrow-btn[disabled] {
    opacity: 0;
    visibility: hidden;
}

.video-widget__arrow-btn.next {
    right: 10px;
    padding-left: 2px;
}

.video-widget__arrow-btn.prev {
    left: 10px;
    padding-right: 2px;
}

.video-widget__keyboard-feedback {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgb(0 0 0 / 0.6);
    color: #fff;
    padding: 14px 20px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 700;
    z-index: 10001;
    pointer-events: none;
    animation: feedbackPulse 0.3s ease;
}

@keyframes feedbackPulse {
    0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.8);
    }

    50% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.1);
    }

    100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        transform: translate(-50%, -50%) scale(.9);
        opacity: 0;
    }

    to {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
    }
}

@keyframes scaleFadeAndCollapse {
    0% {
        transform: translate(4px, -50%) scaleX(0);
        opacity: 0;
    }

    14% {
        transform: translate(4px, -50%) scaleX(1);
        opacity: 1;
    }

    86% {
        transform: translate(4px, -50%) scaleX(1);
        opacity: 1;
    }

    100% {
        transform: translate(4px, -50%) scaleX(0);
        opacity: 0;
    }
}